import { useNavigate } from 'react-router-dom'

const ClassroomBlocked = () => {
  const navigate = useNavigate()

  return (
    <div className='bg-white md:h-screen p-5 pt-24 md:p-2 h-min-screen w-full flex flex-col items-center justify-center overflow-hidden'>
      <div className='max-w-sm text-center'>                    
        <h1 className="text-mirage-950 text-3xl font-semibold my-3">
          This research classroom is for consenting participants only.
        </h1>

        <div className='mt-6'>
          <button
            onClick={() => navigate('/students/classrooms')}
            className="bg-mirage-950 text-white text-md rounded-lg py-2 px-5 shadow-[0_2.5px_32px_0_rgba(0,0,64,0.1)] transition-opacity duration-500 ease-in-out disabled:opacity-20"
          >
            Back to Classrooms
          </button>
        </div>
      </div>
    </div>
  )
}

export default ClassroomBlocked
